import { render, staticRenderFns } from "./EditUserProfileDialog.vue?vue&type=template&id=52bb5d4e&scoped=true"
import script from "./EditUserProfileDialog.vue?vue&type=script&lang=js"
export * from "./EditUserProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb5d4e",
  null
  
)

export default component.exports